<template>
  <div class="store__checkout">
    <h1 class="store-headline">{{ headline }}</h1>
    
    <div v-html="content"></div>
    
    <div class="form">
      <div class="form__left">
        <h2 class="store-headline store-headline--no-border">Account Details</h2>
        
        <div class="mb-2">
          <label for="firstName" class="visually-hidden">First Name</label>
          <input type="text" v-model="firstName" id="firstName" placeholder="First Name" class="form-control" required>
        </div>

        <div class="mb-2">
          <label for="lastName" class="visually-hidden">Last Name</label>
          <input type="text" v-model="lastName" id="lastName" placeholder="Last Name" class="form-control" required>
        </div>
        
        <div class="mb-2">
          <label for="email" class="visually-hidden">Email</label>
          <input type="email" v-model="email" id="email" placeholder="Email" class="form-control" required>
        </div>
        
        <div class="mb-2">
          <label for="phone" class="visually-hidden">Phone Number</label>
          <input type="tel" v-model="phone" id="phone" placeholder="Phone Number" class="form-control" required>
        </div>
        
        <div class="mb-2">
          <label for="address" class="visually-hidden">Delivery Address</label>
          <input type="text" v-model="address" id="address" placeholder="Delivery Address" class="form-control" required>
        </div>
        
        <div class="mb-2">
          <label for="address2" class="visually-hidden">Apt, suite, etc.</label>
          <input type="text" v-model="address2" id="address2" placeholder="Apt, suite, etc." class="form-control">
        </div>

        <div class="mb-2">
          <label for="state" class="visually-hidden">State</label>
          <select v-model="state" id="state" class="form-select" required>
            <option 
              v-for="state in states"
              :value="state.abbrev"
            >{{ state.name }}</option>
          </select>
        </div>
        
        <div class="mb-2">
          <label for="postalCode" class="visually-hidden">Postal Code</label>
          <input type="text" v-model="postalCode" id="postalCode" placeholder="Postal Code" class="form-control" maxlength="5" required>
        </div>
        
        <div class="mb-2">
          <label for="comments" class="visually-hidden">Delivery Instructions</label>
          <textarea v-model="comments" id="comments" placeholder="Delivery Instructions" class="form-control"></textarea>
        </div>
      </div>
      
      <div class="form__right">
        <div class="order-total mb-3">Order Total: ${{ orderTotal }}</div>
        
        <button 
          type="button" 
          class="btn btn-store btn-lg mb-4" 
          :disabled="isProcessing"
          v-on:click="submitOrder()"
        >
          <svg v-if="isProcessing" class="loading-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"/></svg> 
          Place Order
        </button>
        
        <div class="delivery-note" v-html="refundPolicy" v-if="refundPolicy"></div>
      </div>
    </div> <!-- .form -->
          
  </div> <!-- .store__checkout -->
</template>

<script>
import store from '../store.js'
import mixins from '../mixins.js'

export default {
  mixins: [mixins],
  data() {
    return {
      headline: '',
      content: '',
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      address: '',
      address2: '',
      state: window.culligan.defaultState || '',
      postalCode: '',
      comments: '',
    }
  },
  computed: {
    isProcessing() {
      return store.state.isProcessing
    },
    states() {
      return window.culligan.states
    },
    refundPolicy() {
      return store.state.settings.refundPolicy || ''
    },
    orderTotal() {
      return this.numberFormat(store.getters.cartTotal)
    }
  },
  created() {
    // Page content
    // this.headline = window.pages.checkout.page.headline || ''
    // this.content = window.pages.checkout.page.content || ''
  },
  mounted() {
    store.dispatch('setCurrentStep', 'checkout')
  },
  methods: {
    submitOrder() {
      store.dispatch('submitOrder', this.$data)
    }
  }
}
</script>
